import { assert, assertUsage, isObject } from './utils';
export { assertPageContextProvidedByUser };
function assertPageContextProvidedByUser(pageContextProvidedByUser, { hook, errorMessagePrefix, }) {
    if (!errorMessagePrefix) {
        assert(hook);
        const { hookName, hookFilePath } = hook;
        assert(hookFilePath.startsWith('/'));
        assert(!hookName.endsWith(')'));
        errorMessagePrefix = `The \`pageContext\` provided by the \`${hookName}()\` hook (${hookFilePath})`;
    }
    assertUsage(isObject(pageContextProvidedByUser), `${errorMessagePrefix} should be an object.`);
    assertUsage(!('_objectCreatedByVitePluginSsr' in pageContextProvidedByUser), `${errorMessagePrefix} should not be the whole \`pageContext\` object, see https://vite-plugin-ssr.com/pageContext-manipulation#do-not-return-entire-pagecontext`);
    assert(!('_pageId' in pageContextProvidedByUser));
}
